module.exports = __webpack_public_path__ + "img/signin_btn.5c4d5c89.png";